import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editAddressFormatConfig, getListAddressFormatConfig, getManagementHistoryList } from "../../../service/setup/AddressFormatConfig/AddressFormatConfigService";
import { TOKEN } from "../../../constant/apiConstant";
import { onChanged } from "../../../util/Util";
import moment from "moment";

export const useAddFormatConfig = () => {

    const [list, setList] = useState()
    const [isEdit, setIsEdit] = useState(false)
    const [updatedData, setUpdatedData] = useState()
    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [editList, setEditList] = useState()
    const [showConfirm, setShowConfirm] = useState(false)
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
    const [isEdited, setIsEdited] = useState(false)
    const [managementHistoryList, setManagementHistoryList] = useState([])

    useEffect(() => {
        doGetListAddressFormatConfig()
        doGetManagementHistoryList()
    }, [])

    const checkIsEdited = () => {
        if (isEdited) {
            setShowConfirm(true)
        } else {
            setIsEdit(false)
        }
    }

    const doEdit = (isEdit) => {
        setEditList(list?.ListAddressFormatConfiguration.map((item) => ({
            id: item.id,
            field: item.field,
            label: item.label,
            show: item.show == "Yes" ? "Y" : "N",
            mandatory: item.mandatory == "Yes" ? "Y" : "N",
            consider_for_geocoding: item.consider_for_geocoding == "Yes" ? "Y" : "N",
        })))
        setIsEdit(isEdit)
    }

    const updateRow = (row, index, field, value) => {
        setIsEdited(true)
        onChanged(dispatch, true)
        switch (field) {
            case 'show':
                editList[index].show = value
                break;
            case `mandatory`:
                editList[index].mandatory = value
                break;

            case `geocoding`:
                editList[index].consider_for_geocoding = value
                break;
            default:
                break;
        }

        setEditList(editList)
        const list_data = { list_data: editList, updated_at: list.updated_at }

        setUpdatedData(list_data)

    }

    const doGetManagementHistoryList = async (id) => {
        try {
            const response = await getManagementHistoryList(token, null, dispatch);
            if (response && response.ok) {
                const data = response.data
                const reorderedData = []

                for (let i = data.length - 1; i >= 0; i--) {
                    const element = data[i];
                    reorderedData.push(element)
                }

                setManagementHistoryList(reorderedData)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doEditAddressFormatConfig = async (updatedAt) => {
        const list_data = { list_data: editList, updated_at: updatedAt }
        try {
            const response = await editAddressFormatConfig(token, null, (updatedData ? updatedData : list_data), dispatch);
            if (response && response.ok) {
                doGetListAddressFormatConfig()
                setSuccessModalOpen(true)
                doEdit(false)
                onChanged(dispatch, false)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetListAddressFormatConfig = async () => {
        try {
            const response = await getListAddressFormatConfig(token, null, null, dispatch);
            if (response && response.ok) {
                setList(response.data)
                setEditList(list)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const convertToTime = (timestamp) => {
        let time = new Date(timestamp);
        return (moment(timestamp).utc().format('HH:mm'))
    }


    return {
        list,
        convertTimestamp,
        convertToTime,
        editList,
        isEdit,
        setIsEdit,
        doEdit,
        updateRow,
        doEditAddressFormatConfig,
        successModalOpen,
        setSuccessModalOpen,
        setShowConfirm,
        showConfirm,
        checkIsEdited,
        managementHistoryList
    }

}
